import dayjs from "dayjs";
import { Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { formatMoney } from "../../../../utils/util";
import TagJoStatus from "../../../../components/badge-and-tag/ERP/tags-jo-status/TagJoStatus";
import { docLinkRender } from "../../../../components/table/DocLink";

export const fgSummaryColumns = () => [
  {
    title: "FG Code",
    dataIndex: "fg_code",
    key: "fg_code",
    width: 140,
    sorter: (a, b) => (a.fg_code || "").localeCompare(b.fg_code || ""),
  },
  {
    title: "FG Name",
    dataIndex: "fg_name",
    key: "fg_name",
  },
  {
    title: "จำนวนลูกค้า",
    dataIndex: "customer_count",
    key: "customer_count",
    align: "right",
    width: 120,
    sorter: (a, b) => a.customer_count - b.customer_count,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม JO",
    dataIndex: "total_jo",
    key: "total_jo",
    align: "right",
    width: 100,
    sorter: (a, b) => a.total_jo - b.total_jo,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Unit",
    dataIndex: "total_unit",
    key: "total_unit",
    align: "right",
    width: 120,
    sorter: (a, b) => a.total_unit - b.total_unit,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Carton",
    dataIndex: "total_carton",
    key: "total_carton",
    align: "right",
    width: 120,
    sorter: (a, b) => a.total_carton - b.total_carton,
    render: (v) => formatMoney(v, 0),
  },
];

export const fgCustomerSubColumns = ({ onDetail }) => [
  {
    title: "รหัสลูกค้า",
    dataIndex: "cuscode",
    key: "cuscode",
    width: 120,
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "cusname",
    key: "cusname",
  },
  {
    title: "รวม JO",
    dataIndex: "total_jo",
    key: "total_jo",
    align: "right",
    width: 100,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Unit",
    dataIndex: "total_unit",
    key: "total_unit",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Carton",
    dataIndex: "total_carton",
    key: "total_carton",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "",
    key: "action",
    align: "center",
    width: 110,
    render: (_, row) => (
      <Button size="small" icon={<EyeOutlined />} onClick={() => onDetail(row)}>
        ดูรายละเอียด
      </Button>
    ),
  },
];

export const customerSummaryColumns = () => [
  {
    title: "รหัสลูกค้า",
    dataIndex: "cuscode",
    key: "cuscode",
    width: 140,
    sorter: (a, b) => (a.cuscode || "").localeCompare(b.cuscode || ""),
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "cusname",
    key: "cusname",
    sorter: (a, b) => (a.cusname || "").localeCompare(b.cusname || ""),
  },
  {
    title: "จำนวน FG",
    dataIndex: "fg_count",
    key: "fg_count",
    align: "right",
    width: 110,
    sorter: (a, b) => a.fg_count - b.fg_count,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม JO",
    dataIndex: "total_jo",
    key: "total_jo",
    align: "right",
    width: 100,
    sorter: (a, b) => a.total_jo - b.total_jo,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Unit",
    dataIndex: "total_unit",
    key: "total_unit",
    align: "right",
    width: 120,
    sorter: (a, b) => a.total_unit - b.total_unit,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Carton",
    dataIndex: "total_carton",
    key: "total_carton",
    align: "right",
    width: 120,
    sorter: (a, b) => a.total_carton - b.total_carton,
    render: (v) => formatMoney(v, 0),
  },
];

export const customerFgSubColumns = ({ onDetail }) => [
  {
    title: "FG Code",
    dataIndex: "fg_code",
    key: "fg_code",
    width: 140,
  },
  {
    title: "FG Name",
    dataIndex: "fg_name",
    key: "fg_name",
  },
  {
    title: "รวม JO",
    dataIndex: "total_jo",
    key: "total_jo",
    align: "right",
    width: 100,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Unit",
    dataIndex: "total_unit",
    key: "total_unit",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "รวม Carton",
    dataIndex: "total_carton",
    key: "total_carton",
    align: "right",
    width: 120,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "",
    key: "action",
    align: "center",
    width: 110,
    render: (_, row) => (
      <Button size="small" icon={<EyeOutlined />} onClick={() => onDetail(row)}>
        ดูรายละเอียด
      </Button>
    ),
  },
];

export const detailColumns = ({ openJo } = {}) => [
  {
    title: "JO Code",
    dataIndex: "jocode",
    key: "jocode",
    width: 140,
    sorter: (a, b) => (a.jocode || "").localeCompare(b.jocode || ""),
    /* กดรหัสเพื่อเปิดหน้า Job Order */
    render: docLinkRender((rec) => openJo && openJo(rec?.jocode), "เปิดดู Job Order"),
  },
  {
    title: "วันที่",
    dataIndex: "jodate",
    key: "jodate",
    width: 110,
    sorter: (a, b) => (a.jodate || "").localeCompare(b.jodate || ""),
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : ""),
  },
  {
    title: "PG Code",
    dataIndex: "pg_code",
    key: "pg_code",
    width: 140,
  },
  {
    title: "PG Name",
    dataIndex: "pg_name",
    key: "pg_name",
  },
  {
    title: "Carton",
    dataIndex: "carton",
    key: "carton",
    align: "right",
    width: 100,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "Unit/cs",
    dataIndex: "unit_cs",
    key: "unit_cs",
    align: "right",
    width: 80,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "Total Unit",
    dataIndex: "total_unit",
    key: "total_unit",
    align: "right",
    width: 110,
    render: (v) => formatMoney(v, 0),
  },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 120,
    render: (v) => v ? <TagJoStatus result={v} /> : null,
  },
];
